<template>
  <div>
    <v-chip v-if="$vuetify.breakpoint.lgAndUp && engagementLastSuccess" color="white" class="last-updated-date-chip cursor-default" disabled small>
      <v-menu open-on-hover v-model="lastUpdatedDateMenu" attach left offset-y>
        <v-btn id="last-updated-date-lg" aria-label="last-updated-date" slot="activator" fab small :color="dateColour" class="donut-chip-btn">
          <v-icon color="white" class="donut-icon" aria-hidden="false" medium>donut_large</v-icon>
        </v-btn>
        <v-card class="py-1 px-2 white-space-nowrap">
          {{$t('dashboard.last_updated')}}
        </v-card>
      </v-menu>
      {{engagementLastSuccess}}
    </v-chip>

    <v-menu v-if="$vuetify.breakpoint.mdAndDown && engagementLastSuccess" v-model="lastUpdatedDateMenu" class="donut-badge" attach left offset-y>
      <template slot="activator">
        <v-badge :color="dateColour" overlap>
          <template slot="badge">
            <v-icon v-if="lessThanYesterday" color="white" small>priority_high</v-icon>
            <v-icon v-else color="white" small>done</v-icon>
          </template>
          <v-btn id="last-updated-date-md" aria-label="last-updated-date" flat fab small class="donut-btn">
            <v-icon color="white" class="donut-icon" aria-hidden="false" medium>donut_large</v-icon>
          </v-btn>
        </v-badge>
      </template>
      <v-card class="py-1 px-2 white-space-nowrap">
        {{$t('dashboard.last_updated')}} <span class="text-bold">{{engagementLastSuccess}}</span>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import DateFormat from '../../mixins/DateFormat'
  import moment from 'moment-es6'

  export default {
    name: 'last-updated-date',
    mixins: [DateFormat],
    props: {},
    data () {
      return {
        lastUpdatedDateMenu: false,
        yesterday: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        SUCCESS: 'success',
        ERROR: 'error'
      }
    },
    methods: {
    },
    computed: {
      ...mapState({
        engagementLastSuccess: state => state.dashboard.engagementLastSuccess
      }),
      lessThanYesterday () {
        return moment(this.engagementLastSuccess).isBefore(this.yesterday)
      },
      dateColour () {
        return this.lessThanYesterday ? this.ERROR : this.SUCCESS
      }
    }
  }
</script>
<style scoped>
  .last-updated-date-chip {
    font-size: 14px;
    font-weight: 500;
    margin: 12px 6px;
  }
  .donut-icon {
    transform: rotate(180deg);
  }
  .donut-badge {
    margin: 10px 8px 6px 0px;
  }
  .donut-btn {
    margin: -6px -6px 0px 0px;
  }
  .donut-chip-btn {
    margin-left: -15px;
    width: 34px;
    height: 34px
  }
  .text-bold {
    font-weight: 600;
  }
  .white-space-nowrap {
    white-space: nowrap;
  }

  .cursor-default button {
    cursor: default !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/navbar/LastUpdatedDate.vue